import Ajax from '../../../Ajax'
import { Alert, AlertModal } from '../../..'
import { Button } from '@mui/material'
import WorkflowTemplateStepForm from './WorkflowTemplateStepForm'
import InlineMenu from '../../../misc/InlineMenu'
import { Icons } from '../../../misc/Icons'
import WorkflowTemplateForm from './WorkflowTemplateForm'
import { store } from '../../../stores/Store'
import { observer } from 'mobx-react-lite'
import { Workflow, WorkflowStep } from '../../../models/Interfaces'
import React from 'react'


interface WorkflowTemplateProps {
    workflow: Workflow;
}


export default observer(function WorkflowTemplate ({workflow}: WorkflowTemplateProps) {

    const [loading, setLoading] = React.useState(false)
    const writeGranted = store.AppStore.checkJwtRole("sysuser") || (workflow.accountUid && workflow.accountUid === store.AppStore.sessionInfo.userAccount.uid)
    const steps = [...workflow.steps].sort((a, b) => a.orderInd - b.orderInd)

    const reorder = async (step: WorkflowStep, newPosition: number) => {
        setLoading(true)

        var newSteps = steps.filter(s => s.uid !== step.uid)
        newSteps.splice(newPosition, 0, step)
        newSteps.forEach((s, i) => {
            s.orderInd = i
        })

        await Ajax.Workflow.UpdateTemplateStepOrder({...workflow, steps: newSteps}).then(async () => {
            await store.AppStore.getWorkflows()
        }).catch(() => {
            Alert({message: "Failed to reorder steps"})
        })

        setLoading(false)
    }

    return (
        <div className={loading || writeGranted ? "" : "disabled"} style={{display: "grid", gap: "20px", padding: "0 20px 20px 0"}}>
            <div>
                <p>{workflow.description}</p>

                {!steps?.length ? (
                    <p>This Workflow has not steps yet.</p>
                ) : null}
            </div>

            {steps?.map((workflowStep, i) => (
                <div className="tool-section" key={i}>
                    <div className="tool-table" style={{display: "grid", gap: "20px", maxWidth: "600px"}}>
                        <div className="header">
                            <small style={{color: "#adadad"}}>Step {i+1}</small>

                            <InlineMenu 
                                opener={<Icons.More style={{fontSize: "18px"}} />}
                                menuItems={[
                                    {
                                        label: "Delete this step", 
                                        action: () => {
                                            Ajax.Workflow.DeleteTemplateStep(workflowStep.uid).then(() => {
                                                store.AppStore.getWorkflows()
                                            }).catch(() => {
                                                Alert({message: "Failed to delete step"})
                                            })
                                        }
                                    },
                                    {
                                        label: "Move up", 
                                        action: () => reorder(workflowStep, i - 1), 
                                        hidden: i === 0
                                    },
                                    {
                                        label: "Move down", 
                                        action: () => reorder(workflowStep, i + 1), 
                                        hidden: i === workflow.steps.length -1
                                    }
                                ]} />
                        </div>
                        
                        <WorkflowTemplateStepForm 
                            key={i}
                            workflow={workflow} 
                            workflowStep={workflowStep} />
                    </div>
                </div>
            ))}

            {writeGranted ? (
                <div style={{display: "flex", gap: "10px"}}>
                    <Button
                        color="error"
                        variant="contained"
                        className="btn btn-sm"
                        onClick={async () => {
                            setLoading(true)
                            
                            await Ajax.Workflow.DeleteTemplate(workflow.uid).then(() => {
                                store.AppStore.getWorkflows()
                            }).catch(() => {
                                Alert({message: "Failed to delete Workflow"})
                            })
                            
                            setLoading(true)
                        }}>
                        Delete this Workflow
                    </Button>

                    <Button
                        color="info"
                        className="btn-sm"
                        variant="contained"
                        onClick={() => AlertModal({title: "Update Workflow", body: <WorkflowTemplateForm workflow={workflow} />})}>
                        Update
                    </Button>

                    <Button
                        color="info"
                        variant="contained"
                        className="btn btn-sm"
                        onClick={() => {
                            AlertModal({title: "Create Step", body: <WorkflowTemplateStepForm workflow={workflow} />})
                        }}>
                        Add Step
                    </Button>
                </div>
            ) : null}
        </div>
    )
})